import { FACULTY_WORKSPACE_BASE } from './facultyNav';

export { FACULTY_WORKSPACE_BASE };

export const FACULTY_WORKSPACE_NAV = [
  { id: 'overview', label: 'Overview', segment: 'overview' },
  { id: 'batches', label: 'Batches', segment: 'batches' },
  { id: 'assignments', label: 'Assignments', segment: 'assignments' },
  { id: 'interventions', label: 'Interventions', segment: 'interventions' },
];

export function workspacePath(segment) {
  return `${FACULTY_WORKSPACE_BASE}/${segment}`;
}
